export default __webpack_public_path__ + "874232ab896d10d76cf1089f2d7847e5.svg";